import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStepLength = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 34,
	height: 35,
	viewBox: "0 0 34 35",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_91",
		"data-name": "Group 91",
		transform: "translate(0.081 0.964)",
		children: [/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_25",
			"data-name": "Rectangle 25",
			width: 33,
			height: 34,
			transform: "translate(0.419 -0.464)",
			fill: "none",
			stroke: "#040505",
			strokeWidth: 1,
			opacity: 0
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_90",
			"data-name": "Group 90",
			transform: "translate(2.824 0.734)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_216",
					"data-name": "Path 216",
					d: "M163.39,435.077a3.222,3.222,0,0,0,.377.023l.026,0h3.156a1.056,1.056,0,1,0,0-2.111H166.4a12.184,12.184,0,0,0,.642-2.549c.046-.276.088-.525.134-.728.058-.26.2-.7.349-1.169a14.454,14.454,0,0,0,.871-3.877,6.488,6.488,0,0,0-1.779-4.716,3.61,3.61,0,0,0-2.784-.993c-2.2.16-3.352,2.536-3.352,4.8a8.533,8.533,0,0,0,.445,2.6,4.713,4.713,0,0,1,.273,1.355,12.512,12.512,0,0,1-.179,1.631c-.242,1.627-.517,3.472.42,4.7a2.746,2.746,0,0,0,1.949,1.041Zm.6-14.016a1.513,1.513,0,0,1,1.193.433,4.51,4.51,0,0,1,1.105,3.17,13.524,13.524,0,0,1-.771,3.233c-.172.536-.32,1-.4,1.351-.053.233-.1.521-.155.839-.3,1.795-.65,2.979-1.324,2.893-.38-.044-.481-.177-.519-.227-.394-.514-.171-2.01-.008-3.1a13.9,13.9,0,0,0,.2-1.942,6.559,6.559,0,0,0-.361-1.958,6.456,6.456,0,0,1-.357-2C162.592,422.507,163.125,421.123,163.986,421.061Z",
					transform: "translate(-150.031 -418.944)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_217",
					"data-name": "Path 217",
					d: "M187.724,457.126l-1.009,1.009v-4.577l1.009,1.009a1.055,1.055,0,0,0,1.493-1.493l-2.811-2.81a1.055,1.055,0,0,0-.161-.132c-.025-.017-.052-.029-.079-.043a.944.944,0,0,0-.1-.054,1.034,1.034,0,0,0-.106-.033.9.9,0,0,0-.091-.027,1.052,1.052,0,0,0-.414,0,.908.908,0,0,0-.091.027,1.037,1.037,0,0,0-.106.033.949.949,0,0,0-.1.054c-.026.014-.053.026-.079.043a1.059,1.059,0,0,0-.161.132l-2.81,2.81a1.056,1.056,0,1,0,1.493,1.493l1.009-1.009v4.576l-1.009-1.009a1.056,1.056,0,0,0-1.493,1.493l2.811,2.811a1.055,1.055,0,0,0,1.493,0l2.811-2.811a1.056,1.056,0,0,0-1.493-1.493Z",
					transform: "translate(-160.094 -433.587)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_218",
					"data-name": "Path 218",
					d: "M184.349,447.658h3.167a1.056,1.056,0,0,0,0-2.111h-3.167a1.056,1.056,0,1,0,0,2.111Z",
					transform: "translate(-160.802 -431.505)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_219",
					"data-name": "Path 219",
					d: "M187.516,472.794h-3.167a1.056,1.056,0,1,0,0,2.111h3.167a1.056,1.056,0,0,0,0-2.111Z",
					transform: "translate(-160.802 -444.371)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_220",
					"data-name": "Path 220",
					d: "M169.942,472.794h-5.166a1.056,1.056,0,1,0,0,2.111h5.166a1.056,1.056,0,1,0,0-2.111Z",
					transform: "translate(-151.561 -444.371)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_221",
					"data-name": "Path 221",
					d: "M148.733,460.234h-.593a9.453,9.453,0,0,0-.081-3.646,12.612,12.612,0,0,1-.179-1.632,4.71,4.71,0,0,1,.273-1.354,8.534,8.534,0,0,0,.445-2.6c0-2.264-1.152-4.64-3.352-4.8a3.622,3.622,0,0,0-2.784.993,6.487,6.487,0,0,0-1.779,4.715,14.44,14.44,0,0,0,.873,3.88c.149.467.291.907.349,1.166.045.2.086.45.132.726.259,1.539.784,4.664,3.275,4.664.055,0,.115-.007.172-.011.027,0,.054.009.082.009h3.167a1.056,1.056,0,1,0,0-2.111Zm-4.769-3.739c-.078-.352-.226-.814-.4-1.349a13.545,13.545,0,0,1-.772-3.235,4.511,4.511,0,0,1,1.106-3.17,1.516,1.516,0,0,1,1.067-.437q.063,0,.127,0c.861.062,1.393,1.447,1.393,2.694a6.461,6.461,0,0,1-.357,2,6.569,6.569,0,0,0-.361,1.957,13.846,13.846,0,0,0,.2,1.942c.163,1.092.385,2.588-.009,3.1-.038.049-.139.182-.518.226-.694.085-1.023-1.1-1.325-2.895C144.066,457.015,144.017,456.728,143.964,456.495Z",
					transform: "translate(-140.683 -431.81)",
					fill: "#101820"
				})
			]
		})]
	})]
});
const ForwardRef = forwardRef(SvgStepLength);
export { ForwardRef as ReactComponent };
